import React, { useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Breadcrumb, Button, Card } from 'react-bootstrap';
import { FiArrowLeft, FiLayers } from 'react-icons/fi';
import SubCoverageCreateForm from './SubCoverageCreateForm';
import useSubCoverageCreate from './useSubCoverageCreate';
import './SubCoverageCreate.css';

/**
 * Page : Nouvelle sous-couverture activité
 * Route : /activity/subcoverages/create
 */
const SubCoverageCreatePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const initialPartnerId = useMemo(
        () =>
            searchParams.get('partner_id') ||
            location.state?.partnerId ||
            location.state?.partner_id ||
            '',
        [searchParams, location.state]
    );

    const initialReferenceId = useMemo(
        () =>
            searchParams.get('reference_id') ||
            location.state?.referenceId ||
            location.state?.reference_id ||
            '',
        [searchParams, location.state]
    );

    const contextLocked = Boolean(initialPartnerId && initialReferenceId);

    const {
        partners,
        references,
        loadingPartners,
        loadingReferences,
        selectedPartnerId,
        selectedReferenceId,
        selectPartner,
        selectReference,
        submitting,
        submitError,
        fieldErrors,
        successMessage,
        submit,
    } = useSubCoverageCreate({
        initialPartnerId,
        initialReferenceId,
    });

    const handleCancel = () => {
        navigate('/activity/subcoverages');
    };

    const handleSubmit = async (values) => {
        await submit({
            ...values,
            partner_id: selectedPartnerId || values.partner_id,
            reference_id: selectedReferenceId || values.reference_id,
        });
    };

    return (
        <div className="dashboard-page scc-page">
            <div className="scc-page__inner">
                <Breadcrumb className="scc-breadcrumb">
                    <Breadcrumb.Item onClick={() => navigate('/activity/activities')} linkAs="button">
                        Activité
                    </Breadcrumb.Item>
                    <Breadcrumb.Item onClick={() => navigate('/activity/subcoverages')} linkAs="button">
                        Sous-couvertures
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Nouvelle sous-couverture</Breadcrumb.Item>
                </Breadcrumb>

                <div className="scc-page__header">
                    <div>
                        <h1 className="scc-page__title">
                            <FiLayers className="me-2" aria-hidden="true" />
                            Nouvelle sous-couverture
                        </h1>
                        <p className="scc-page__subtitle">
                            Configurez les conditions de déclenchement, la période de couverture,
                            la localisation et les paramètres financiers.
                        </p>
                    </div>
                    <Button
                        variant="outline-secondary"
                        onClick={handleCancel}
                        className="scc-page__back"
                    >
                        <FiArrowLeft className="me-2" aria-hidden="true" />
                        Retour
                    </Button>
                </div>

                <Card className="scc-page__card border-0 bg-transparent">
                    <Card.Body className="p-0">
                        <SubCoverageCreateForm
                            partners={partners}
                            references={references}
                            loadingPartners={loadingPartners}
                            loadingReferences={loadingReferences}
                            selectedPartnerId={selectedPartnerId}
                            selectedReferenceId={selectedReferenceId}
                            onPartnerChange={selectPartner}
                            onReferenceChange={selectReference}
                            contextLocked={contextLocked}
                            submitting={submitting}
                            submitError={submitError}
                            successMessage={successMessage}
                            apiFieldErrors={fieldErrors}
                            onSubmit={handleSubmit}
                            onCancel={handleCancel}
                        />
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

export default SubCoverageCreatePage;
